import { useTranslation } from 'react-i18next';
import { verifierAddress } from '../ton/config';

interface VerifiedBadgeProps {
  /** Friendly-form contract address whose sources are verified. */
  address: string | null;
  /** Override the default badge label. */
  label?: string;
}

/**
 * A click-through badge linking to the contract's source-code verification on
 * verifier.ton.org. Renders nothing without an address.
 */
export function VerifiedBadge({ address, label }: VerifiedBadgeProps) {
  const { t } = useTranslation();
  if (!address) return null;
  return (
    <a
      className="verified-badge"
      href={verifierAddress(address)}
      target="_blank"
      rel="noopener noreferrer"
      title={t('verified.tooltip')}
    >
      <img
        src="/ton-verifier.svg"
        alt=""
        className="verified-badge__icon"
        aria-hidden
        width={16}
        height={16}
      />
      <span>{label ?? t('verified.badge')}</span>
    </a>
  );
}
